import { render } from "./VehicleBrandings.vue?vue&type=template&id=e8307a2e&scoped=true"
import script from "./VehicleBrandings.vue?vue&type=script&lang=js"
export * from "./VehicleBrandings.vue?vue&type=script&lang=js"

import "./VehicleBrandings.vue?vue&type=style&index=0&id=e8307a2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8307a2e"]])

export default __exports__